import React, { useContext } from 'react'
import { DeviceContext } from '../../services/Context'
import { State, Dispatch } from '../../store'
import { MAX_NAME_LENGTH } from '@common/constants'
import { useSelector, useDispatch } from 'react-redux'
import { safeHostname } from '@common/nameHelper'
import { useTranslation } from 'react-i18next'
import { InlineTextFieldSetting, InlineTextFieldSettingProps } from '../InlineTextFieldSetting'
import { getDevices } from '../../selectors/devices'

export const DeviceNameSetting: React.FC<InlineTextFieldSettingProps> = props => {
  const { device } = useContext(DeviceContext)
  const dispatch = useDispatch<Dispatch>()
  const { t } = useTranslation()
  const hostname = useSelector((state: State) => state.backend.environment.hostname)
  const nameBlacklist = useSelector(getDevices)
    .filter((device: IDevice) => !device.shared)
    .map((d: IDevice) => d.name.toLowerCase())

  if (!device) return null

  const name = device.name
  const defaultValue = device.thisDevice ? safeHostname(hostname, nameBlacklist) : device.name

  return (
    <InlineTextFieldSetting
      required
      value={name}
      icon="i-cursor"
      label={t('deviceNameSetting.label', 'Device Name')}
      disabled={!device.permissions.includes('MANAGE')}
      resetValue={defaultValue}
      maxLength={MAX_NAME_LENGTH}
      onSave={name => {
        dispatch.accounts.setDevice({ id: device.id, device: { ...device, name: name.toString() } })
        dispatch.devices.rename({ id: device.id, name: name.toString() })
      }}
      {...props}
    />
  )
}
